
import React from "react";
import "../NavBar/Navbar.css";
import { useSelector, useDispatch } from "react-redux";
import { loginReducer } from "../../Redux/store";
import { AccessTockenReducer } from "../../Redux/store";
import axios from "axios";

import { sidebarReducer } from "../../Redux/store";
import { FaBars } from "react-icons/fa";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Typography } from "@mui/material";
import { useMsal } from "@azure/msal-react";

const Navbar = (props) => {
  const { instance } = useMsal();
  const token = useSelector((state) => state.AccessTocken.accessTocken);
  const refreshToken = useSelector((state) => state.AccessTocken.refreshTocken);
  const userName = useSelector((state) => state.Login.loginUser_name);
  const dispatch = useDispatch();
  // const [anchorEl, setAnchorEl] = React.useState(null);
  // const toggled = useSelector((state) => state.AccessTocken.sidebarToggle);
  // const open = Boolean(anchorEl);

  let options = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const ShowRecord = () => {
    sessionStorage.setItem("navigate", "Settings");
    dispatch(sidebarReducer.stringUpdate("Settings"));
  };

  const logoutHandler = async (e) => {
    e.preventDefault();
    if (token) {
      const response = await axios.post(
        "auth/logout",
        { accessToken: token, refreshToken: refreshToken },
        options
      );
      if (response.status === 200) {
        dispatch(loginReducer.Logout());
        dispatch(AccessTockenReducer.accessTocken(""));
        dispatch(AccessTockenReducer.refreshTocken(""));
        sessionStorage.clear();
      }
    } else {
      instance.logoutRedirect({ postLogoutRedirectUri: "/" });
    }
  };
  // const classes = useStyles();
  // const handleMenu = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  return (
    <header>
      <div className="root">
        <AppBar>
          <Toolbar>
            <div
              className={`btn-toggle menuButton`}
              onClick={() => dispatch(AccessTockenReducer.sidebar_toggle(true))}
              // onClick={() =>
              //   dispatch(AccessTockenReducer.sidebar_toggle(true));
              // }
            >
              <FaBars />
            </div>
            <Typography variant="h6" className="title">
              <div className="jiobp-logo">
              <img
                style={{ height: "45px" }}
                src={require("../../images/JioBPLOgo.png")}
                alt="TATA Elxsi"
              />
              </div>
            </Typography>

            <div className="d-flex flex-row-reverse">
              <div className="p-2">
                <div className="dropstart pt-1">
                  <a
                    className="nav-link dropdown-toggle"
                    href="ntng"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img
                      className="p-1"
                      src={require("../../images/user.png")}
                      alt="user"
                      style={{
                        height: "40px",
                        width: "40px",
                      }}
                    />
                  </a>
                  <ul className="dropdown-menu dropmenu position-absolute">
                    {/* <li>
                      <p className="dropdown-item">
                        <i className="bi bi-person-fill px-2"></i>Profile
                      </p>
                    </li> */}
                    <li>
                      <p className="dropdown-item" onClick={ShowRecord}>
                        <span style={{ cursor: "pointer" }}>
                          <i className="bi bi-sliders px-2"></i>Settings
                        </span>
                      </p>
                    </li>
                    <li>
                      <hr className="dropdown-divider" />
                    </li>
                    <li>
                      <form onSubmit={logoutHandler}>
                        <button className="dropdown-item" href="/">
                          <i className="bi bi-box-arrow-left px-2"></i>
                        
                          Log Out
                        </button>
                      </form>
                    </li>
                 
                  </ul>
                </div>
              </div>
              <div className="py-3 px-2 border-light text-white border-start border-opacity-25">
                <h4>{userName}</h4>
              </div>
            </div>
          </Toolbar>
        </AppBar>
      </div>
    </header>
  );
};

export default Navbar;
